import Enum from 'enum';

export const PLATFORMS = [
    'IOS',
    'ANDROID',
    'TEAMS',
    'INTEGRATION',
    'TEAMSFV',
    'TEAMSFVMANUAL',
];

/**
 * The type of application embedding the web app.
 */
export default new Enum(PLATFORMS, {
    ignoreCase: true,
});
